/**
 * Saber que hay un despliegue nuevo mientras la pestaña sigue abierta.
 *
 * Cada build lleva un identificador propio (`__BUILD_ID__`) y publica el mismo en
 * `/version.json`. La pestaña pregunta de vez en cuando cuál se está sirviendo, y
 * si ya no es el suyo es que alguien desplegó después de que ella cargara.
 *
 * Existe porque el aviso que había no se encendía nunca: comparaba la versión de
 * `package.json`, que es 1.0.0 desde siempre. El 29 sep 2026 el administrador
 * global no veía el organigrama recién desplegado, con todos sus permisos
 * encendidos, porque tenía abierta la pestaña de la mañana.
 */

/** El identificador que dice el servidor, o `null` si no se entiende. */
export const readServedBuild = (payload: unknown): string | null => {
  if (typeof payload !== 'object' || payload === null || !('build' in payload)) return null;
  const build = payload.build;
  return typeof build === 'string' && build.trim().length > 0 ? build.trim() : null;
};

/**
 * Si lo servido es otro build que el que corre.
 *
 * Una respuesta ilegible **no** cuenta como despliegue nuevo: un aviso de
 * «recarga» que sale porque falló la red enseña a ignorarlo, y el día que sea de
 * verdad nadie recarga.
 */
export const isNewDeployment = (running: string, served: string | null): boolean =>
  served !== null && running.length > 0 && served !== running;

/**
 * El atajo para recargar sin caché, en el teclado de quien mira.
 *
 * Se escribe el suyo y no los dos: el aviso lo lee alguien a media tarea, y
 * «⌘ ⇧ R en Mac, Ctrl + Shift + R en Windows» le hace buscar cuál es el suyo.
 */
export const reloadShortcut = (platform: string): string =>
  /mac|iphone|ipad|ipod/i.test(platform) ? '⌘ ⇧ R' : 'Ctrl + Shift + R';
